import type { PublicApiKey } from '@/apilib';
import type { createComponentsApi } from './componentsWrapper';

export const ComponentsApiKey: PublicApiKey<typeof createComponentsApi> = {
  name: 'ComponentsApi',
  public: true,
};
